import { NbDialogService } from "@nebular/theme/components/dialog/dialog.service";
import { ModalAcaoComponent } from "../components/modals/modal-acao/modal-acao.component";
import { EColumnType } from "../components/table/EColumnType";
import { ILoteDetalhes } from "../dto/ILoteDetalhes";
import { EAcaoType } from "../enums/EAcaoType";
import { getProductDescription } from "./get-product";

export function abrirModalConfirmarCadastro(
  dialogService: NbDialogService,
  params: {
    produto?: string;
    emitirCartao: string;
    textButtonConfirm: string;
    loteDetalhes: ILoteDetalhes;
  },
  onConfirm: any,
  onCancel: any
) {
  let dialogData;
  if (params.emitirCartao === "SIM") {
    dialogData = [
      {
        label: "Produto",
        value: getProductDescription(),
        type: EColumnType.STRING,
      },
      {
        label: "Quantidade cadastrada",
        value:
          (params.loteDetalhes.qtdImportada || 0) -
          (params.loteDetalhes.qtdErros || 0),
        type: EColumnType.NUMBER,
      },
      {
        label: "Data de criação",
        value: params.loteDetalhes.dataCadastro,
        type: EColumnType.DATE,
      },
      {
        label: "Tipo de cartão",
        value: params.loteDetalhes.tipo,
        type: EColumnType.STRING,
      },
      {
        label: "Quantidade de cartões",
        value: params.loteDetalhes.qtdCartoes,
        type: EColumnType.NUMBER,
      },
      {
        label: "Custo unidade",
        value: params.loteDetalhes.valorUnidade || 0,
        type: EColumnType.CURRENCY,
      },
      {
        label: "Valor total",
        value:
          (params.loteDetalhes.valorUnidade || 0) *
          params.loteDetalhes.qtdCartoes,
        type: EColumnType.CURRENCY,
      },
    ];
  } else {
    dialogData = [
      {
        label: "Quantidade cadastrada",
        value:
          (params.loteDetalhes.qtdImportada || 0) -
          (params.loteDetalhes.qtdErros || 0),
        type: EColumnType.NUMBER,
      },
      {
        label: "Data de criação",
        value: params.loteDetalhes.dataCadastro,
        type: EColumnType.DATE,
      },
    ];
  }

  dialogService
    .open(ModalAcaoComponent, {
      closeOnBackdropClick: false,
      closeOnEsc: false,
      context: {
        data: {
          title: "Confirmar cadastro",
          messageFooter: "Tem certeza que deseja finalizar o cadastro?",
          textButtonConfirm: params.textButtonConfirm || 'CONTINUAR',
          acaoType: EAcaoType.CONFIRMAR,
          data: dialogData,
        },
      },
    })
    .onClose.subscribe((result) => {
      if (result === true && onConfirm !== null) {
        onConfirm();
      } else if (onCancel !== null) {
        onCancel();
      }
    });
}
